/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Não vender nem partilhar as minhas informações pessoais",
      "Bumble Date",
      "Aplicações",
      "Quem somos",
      "Empregos",
      "Entra em contacto",
      "Investidores",
      "Loja",
      "Empresa",
      "Instalar a aplicação",
      "Acessibilidade no Bumble",
      "Regras",
      "Gestão de cookies",
      "Lei contra a escravidão moderna",
      "Notificação de recolha de dados",
      "Política de privacidade",
      "Termos e condições",
      "Aspetos legais",
      "Política de privacidade dos dados de saúde do consumidor de Washington",
      "Lê o código QR para instalares a aplicação do Bumble",
      "Terminar aqui os contratos",
      "Fechar menu",
      "Abrir menu",
      "Seleção de idioma",
      "Rodapé",
      "Acessibilidade no Bumble",
      "A Apple e o logótipo da Apple são marcas registadas da Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Vagas",
      "Google Play é uma marca comercial da Google LLC.",
      "Regras",
      "Investidores",
      "Gerir Cookies",
      "Lei sobre Escravatura Moderna",
      "Notificação de recolha de dados",
      "Política de Privacidade",
      "Guias sazonais de encontros",
      "Termos e Condições",
      "App",
      "Política de privacidade dos dados de saúde do consumidor de Washington",
      "Sobre",
      "Embaixadores",
      "Faz amizades e encontra a tua comunidade",
      "Liga-te a profissionais e avança na carreira",
      "Encontra uma relação séria, casual ou algo entre uma e a outra.",
      "O Buzz",
      "Saber mais",
      "Vê o mundo com o Modo Viagem",
      "Date",
      "Recursos",
      "Compliments",
      "Utiliza o Compliments para te destacares das multidões.",
      "Descobre",
      "Uma página personalizada que destaca as pessoas mais compatíveis contigo, atualizada diariamente.",
      "Modo Invisível",
      "Usa o Modo Invisível para ocultar o perfil do patrão, ex ou dos parentes.",
      "Ligação imediata",
      "Começaste uma conversa num encontro do Bumble? Continua a conversar na app.",
      "Opening Moves",
      "Seleciona Opening Moves para dares a oportunidade a alguém de iniciar uma conversa. Assim, não terás tu de o fazer.",
      "Modo Não Perturbar",
      "Faz uma pausa com o Não Perturbar. Quando quiseres voltar, sabes onde nos encontrar.",
      "SuperSwipe",
      "O perfil passou a prova dos nove? Diz-lhe com um SuperSwipe.",
      "Modo Viagem",
      "Encontra a tua felicidade em qualquer parte do mundo com o Modo Viagem.",
      "Videochamada",
      "Utiliza o videochat e as videochamadas para veres se estão prontos para se encontrarem em pessoa.",
      "Aplicação web",
      "Experimenta o Bumble diretamente no teu navegador.",
      "Obtém a app do Bumble",
      "BFF",
      "Segurança",
      "Histórias",
      "Apoio",
      "Loja",
      "Navegação principal",
      "Utiliza o Compliments para te destacares das multidões.",
      "Compliments",
      "Recursos criados para fomentar ligações reais, respeitosas e significativas.",
      "Usa o Modo Invisível para ocultar o perfil do patrão, ex ou de familiares.",
      "Modo Invisível",
      "Faz uma pausa dos encontros com o Não perturbar.",
      "Modo Não perturbar",
      "Viste alguém que te agradou? Não deixes escapar o momento.",
      "SuperSwipe",
      "Explora o Date",
      "Liga-te onde quer que estejas.",
      "Modo Viagem",
      "Vê e interage com as ligações antes de se encontrarem.",
      "Videochamadas",
      "Líderes que ajudam a transmitir os valores do Bumble para as comunidades por todo o país.",
      "Líderes da comunidade",
      "Recursos criados para te ligares e encontrares pessoas com interesses em comum.",
      "Organiza um encontro em grupo ou encontra eventos perto de ti.",
      "Plans",
      "Explorar o BFF",
      "Toda a orientação e inspiração de que necessitas para encontrares amor e amizade.",
      "Conselhos e histórias para construíres as amizades que tens em mente.",
      "O espaço da amizade",
      "De Tóquio a Toronto, explora os casos de sucesso do Bumble por todo o mundo.",
      "Histórias de amor",
      "Planeia um encontro perfeito — independentemente do dia, local ou pessoa.",
      "Guias sazonais de encontros",
      "Lê histórias",
      "Ler mais",
      "Bumble no {{social_network}}",
      "Contacto",
      "Entrar",
      "(abre em nova janela)",
      "FAQ",
      "Política de Cookies",
      "Blogue do Bumble",
      "Vagas",
      "Chat",
      "Cidades",
      "Gerir cookies",
      "Copyright (c) 2006 - presente. Bumble, todos os direitos reservados.",
      "Relatório de Relacionamentos com Confiança",
      "A Apple e o logótipo da Apple são marcas registadas da Apple Inc.{{__EOL__}}Google Play é uma marca comercial da Google LLC.",
      "Instalar",
      "Facebook",
      "Siga-nos",
      "Centro de Apoio",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble é parte da Bumble Inc.",
      "Política de Privacidade",
      "Centro de Segurança",
      "Mapa do Site",
      "Sobre a Lei contra a escravidão moderna",
      "Termos e condições",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
